import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { FORECAST_PAGINATOR_MONTHS } from "../../constants";

const ForecastMonthsPaginator = ({
  months,
  month,
  handleSelectMonths,
}): JSX.Element => {
  const [yearMonths, setYearMonths] = useState([]);
  const [year, setYear] = useState(month.split("-")[0]);

  useEffect(() => {
    if (months.length) {
      setYearMonths(
        months.filter(
          (item: string) => item.split("-")[0] === month.split("-")[0]
        )
      );
    }
  }, [months]);

  useEffect(() => {
    setYearMonths(
      months.filter((item: string) => {
        return item.split("-")[0] == String(year);
      })
    );
  }, [year]);

  const handleYearChange = (val) => {
    setYear((prev) => Number(prev) + val);
  };

  const checkNextYearDisabled = () => {
    if (months[months.length - 1] === yearMonths[yearMonths.length - 1]) {
      return true;
    }
    return false;
  };

  const checkPrevYearDisabled = () => {
    if (months[0] === yearMonths[0]) {
      return true;
    }
    return false;
  };

  return (
    <React.Fragment>
      <div id="months-carousel" className="item-container m-05r">
        <div
          className={checkPrevYearDisabled() ? "disabled gray m-05r" : "m-05r"}
        >
          <ChevronLeft
            onClick={() => {
              handleYearChange(-1);
            }}
          />
        </div>
        {yearMonths.map((item, index) => (
          <div
            className={`p-05r ${item === month && "active"}`}
            key={index}
            onClick={() => handleSelectMonths(yearMonths[index])}
            role="button"
            data-month={item.split("-")[1]}
            tabIndex={0}
          >
            {FORECAST_PAGINATOR_MONTHS[Number(item.split("-")[1]) - 1]}
          </div>
        ))}
        <div
          className={checkNextYearDisabled() ? "disabled gray m-05r" : "m-05r"}
        >
          <ChevronRight
            onClick={() => {
              handleYearChange(1);
            }}
          />
        </div>
      </div>
      <div id="painator-year-label" className="item-container">
        {year}
      </div>
    </React.Fragment>
  );
};

export default ForecastMonthsPaginator;
